import { Theme, darken, lighten } from '@material-ui/core/styles';
import { AlertClassKey } from '@material-ui/lab/Alert';

const MuiAlert = (theme: Theme): Partial<Record<AlertClassKey, unknown>> => {
    const getBackgroundColor = theme.palette.type === 'light' ? lighten : darken;

    return {
        root: {
            color: theme.palette.text.primary,
        },
        filledWarning: {
            color: theme.palette.warning.contrastText,
        },
        filledInfo: {
            color: theme.palette.info.contrastText,
            backgroundColor: theme.palette.primary.main,
        },
        filledSuccess: {
            color: theme.palette.success.contrastText,
        },
        filledError: {
            color: theme.palette.error.contrastText,
        },
        standardWarning: {
            color: theme.palette.text.primary,
        },
        standardInfo: {
            color: theme.palette.text.primary,
            backgroundColor: getBackgroundColor(theme.palette.primary.main, 0.9),
            '& $icon': {
                color: theme.palette.primary.main,
            },
        },
        standardSuccess: {
            color: theme.palette.text.primary,
        },
        standardError: {
            color: theme.palette.text.primary,
        },
        outlinedWarning: {
            color: theme.palette.text.primary,
        },
        outlinedInfo: {
            color: theme.palette.text.primary,
            border: `1px solid ${theme.palette.primary.main}`,
            '& $icon': {
                color: theme.palette.primary.main,
            },
        },
        outlinedSuccess: {
            color: theme.palette.text.primary,
        },
        outlinedError: {
            color: theme.palette.text.primary,
        },
    };
};

export default MuiAlert;
